import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getHotTopicsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/hot-topics");

  return response.data;
};
